import * as React from 'react';
import { Spinner } from '../../../components/common';
import { Button } from '../../../components/buttons';
import { IconChevronLeft, IconChevronRight } from '../../../components/icons';
import { connect } from 'react-redux';

interface Props {
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
	isNextDisabled: () => boolean;
	isLoading?: boolean;
	navigationEnabled: boolean;
}
const NextPreviousButtons: React.StatelessComponent<Props> = props => {
	const onClick = (callback: any) => {
		// TODO: Animate scroll
		window.scrollTo(0, 0);
		callback();
	};

	return (
		<div className="workflow-progress-actions">
			<Button 
				onClick={() => onClick(props.prevStep)} 
				className="btn-outline-primary workflow-progress-action"
				disabled={!props.navigationEnabled}
			>
				<IconChevronLeft />
				<span className="align-middle mx-2 d-none d-sm-inline-block">Back</span>
			</Button>
			<Button
				onClick={() => onClick(props.nextStep)}
				className="btn-primary workflow-progress-action"
				disabled={!props.navigationEnabled || props.isNextDisabled()}
			>
				<span className="align-middle mx-2">Next</span>
				{!props.isLoading && <IconChevronRight />}
				{props.isLoading && <Spinner />}
			</Button>
		</div>
	);
};

function mapStateToProps(state: any) {
	return {
		navigationEnabled: state.settings.questionnaireNavigationEnabled,
	};
}
export default connect(mapStateToProps)(NextPreviousButtons);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/NextPreviousButtons.tsx